import React, { FC } from "react";
import { Component, GroupBlockEntityType } from "../../../configMap";
import { EntityAnnotation } from "../../../annotation";
import NumberEntity from "./number/NumberEntity";
import DateEntity from "./date/DateEntity";
import WeekEntity from "./week/WeekEntity";
import TextEntity from "./text/TextEntity";
import "./EntitySwitch.scss";

export type EntitySwitchProps = {
  entityType: GroupBlockEntityType;
  entityAnnotation: EntityAnnotation;
  isEditing: boolean;
  isAnnotating: boolean;
  groupBlockIndex: number;
  requiresAttention?: boolean;
  disabled?: boolean;
  documentId?: string;
  showLabels?: boolean;
  isEditable?: boolean;
  showNormalizedValue?: boolean;
  // TableControls props
  isTableMode?: boolean;
  cellClasses?: string;
};

const EntitySwitch: FC<EntitySwitchProps> = (props) => {
  const {
    entityType: { entityType },
    isTableMode = false,
  } = props;

  const commonProps = {
    ...props,
    isTableMode,
  };

  switch (entityType.component.toLowerCase()) {
    case Component.NUMBER.toLowerCase():
      return <NumberEntity {...commonProps} />;
    case Component.DATE.toLowerCase():
      return <DateEntity {...commonProps} />;
    case Component.WEEK.toLowerCase():
      return <WeekEntity {...commonProps} />;
    default:
      return <TextEntity {...commonProps} />;
  }
};

export default EntitySwitch;
